
const en = {
    Language: 'English',
    Login: {
      rememberMe: 'Remember Me',
      login: 'Login',
      enterUsername: 'Please enter your username',
      enterPassword: 'Please enter your password'
    },
    headLine:'{ENtitle}',//标题
    navTopTitle:'{enTitle}',//导航栏
    navTitle:'{enTitle}',//导航栏
    jobPosting:'{enTitle}',//导航栏
    companyInfo:'{enTitle}',//公司信息
    allTitle:'{enTitle}',//公司信息
    WeChatTitle:'WeChat Official Account',
    record:'Filing No',
    follow:"Follow Ruiji's Official Account",
    getInfo:'Stay Updated with Our Latest News',
     descriptionInfo:'Technology Warms Life   Intelligence Empowers the Future',
     copyright:'Copyright © Guangdong Ruiji Internet of Things Technology Co.ltd',
     employeeRecruitment:'Employee Recruitment',
     employeedescript:"Ruiji Technology values talents and firmly believes that talents are the core driving force for the company's development.",
    changeLanguage:'changeLanguage',
    allProduct:'allProduct',
    sumbitTitle:'Submit Immediately',
    aboutRuiji:require('../../../public/image/aboutRuiji.jpg')
    }
  export default en 